import React, { Component } from 'react'
import SearchBar from './SearchBar'

export class MobileSearchBar extends Component {
  
  showFilterMenu=()=>{

  }

  render() {
    
    return (
      <div className="mobile-search-bar">
        {/* <div className="filter-icon" onClick={this.showFilterMenu}>
          <img src={require('../../assets/icons/filter.svg')} alt=""/>
        </div> */}
        <SearchBar />
      </div>
    )
  }
}

export default MobileSearchBar
